
(function () {
    'use strict';

    angular.module('tabModule', [])
           .controller('TabController', tabController);

    tabController.$inject = ['$scope', 'tabStateService', 'readingConfirmationService', 'feedBackService', 'documentService', '$location', 'broadcastService'];

    function tabController($scope, tabStateService, readingConfirmationService, feedBackService, documentService, $location, broadcastService) {
        var vm = this;

        vm.feedbackText = '';
        vm.setState = setState;
        vm.initializeTabs = initializeTabs;
        vm.sendFeedback = sendFeedback;
        vm.sendReadingConfirmation = sendReadingConfirmation;
        vm.getConfirmInformation = getConfirmInformationBaseOnView;

        function setState(tabId, tabType) {
            var tabStateType = getTabStateType(tabType);
            
            setFocusTextSearchForTabActive(tabId);

            if (tabStateService.isTabActive(tabId)) {
                var extendHeight = $('#tab-content-document').height();
                tabStateService.removeState(tabStateType);
                if (tabId == "more-tab") {
                    const activeItem = {
                        tabId: '#more-tab',
                        tabContentId: '.tab-content.home-content #tab8'
                    }
                    angular.element(activeItem.tabId).toggleClass('active');
                    angular.element(activeItem.tabContentId).toggleClass('active');
                    triggerTabClicked('#more-tab', false);
                }

                var documentContentHeight = $('#document-content-identifier').outerHeight();
                var documentFieldListHeight = $('#documentDetailFieldContentList').outerHeight();

                angular.element('#document-content-identifier').css({
                    height: documentContentHeight + extendHeight
                });
                angular.element('#documentDetailFieldContentList').css({
                    maxHeight: documentFieldListHeight + extendHeight
                });
                
            } else {
                tabStateService.setState(tabStateType, tabId);
                tabStateService.setCurrentTabState(tabId);
            }
			var element = $location.url().split('/');
			if (tabId.includes('document') && element[3] != 'fields' && element[3] != 'hearingfields') {
                setTimeout(function () { documentService.stickyTitle(); }, 0);
            }

            if ($('#folder-content-identifier').position()) {
                setTimeout(() => {
                    tabStateService.adjustFolderContentIdentifierHeight();
                    broadcastService('processChangeHeightForTable');
                }, 100);
            }

            setTimeout(function () {
                $scope.$apply(function () {
                    $scope.$broadcast("tabActived", tabId);
                });
            }, 100);
        };

        function triggerTabClicked(tabId, clickItSelf) {
            setTimeout(function () {
                var childTab = $(tabId + ' a');
                if (childTab) {
                    $(childTab).click();
                    if (clickItSelf && $(tabId)) {
                        $(tabId).click();
                    }
                }
            });
        }

        function initializeTabs(tabType, isInitReadingConfirmationTab) {
            var _tabStateType = getTabStateType(tabType);
            tabStateService.setCurrentStateType(_tabStateType);

            var tabState = tabStateService.getState(_tabStateType);
            if ((tabState == null || tabState == "") && _tabStateType == tabStateType.homeTabState) {
                tabStateService.setState(tabStateType.homeTabState, homeTabs.startPage);
            }
            else {
                setState(tabState, tabType);
            }

            setFocusTextSearchForTabActive(tabState);

            tabStateService.initTabState(_tabStateType);
            if (isInitReadingConfirmationTab) {// not loading data again if fieldview
                initializeReadingReceiptTab();
            }
        };

        function setFocusTextSearchForTabActive(tabState) {
            if (tabState != null) {
                if (tabState == 'document-searchincontent') {
                    setTimeout(function () {
                        angular.element('#input-search-in-document').focus();
                    }, 0);
                }
            } 
        };

        function sendFeedback() {
            if (vm.feedbackText == '' || vm.feedbackText == null) {
                alert(globalResources.PleaseEnterFeedback);
                return false;
            }
            return feedBackService
                .sendFeedback($scope.$parent.vm.currentData.entityId, vm.feedbackText)
                .then(function (data) {
                    if (data == true) {
                        vm.feedbackText = '';
                        alert(globalResources.ThanksForYourFeedback);
                    }
                });
        };

        function sendReadingConfirmation() {
            var currentData = $scope.$parent.vm.currentData;
            if (currentData.confirmInformation) {
                readingConfirmationService
                    .sendReadingConfirmation(currentData.entityId, currentData.folderId)
                    .then(function (data) {
                        if (data) {
                            var currentDate = new Date();
                            currentData.confirmInformation.readConfirmationDate = currentDate.toLocaleDateString();
                        }
                    });
            }
        }

        function getConfirmInformationBaseOnView() {
            if ($scope.$parent.vm.currentDataPromise) { //documentView
                $scope.$parent.vm.currentDataPromise.then(function (data) {
                    if (data.entityId && !data.confirmInformation) {
                        getConfirmInformation(data);
                    }
                });
            }
            else { //fieldView
                if ($scope.$parent.vm.currentData.entityId && !$scope.$parent.vm.currentData.confirmInformation) {
                    getConfirmInformation($scope.$parent.vm.currentData);
                }
            }
        };

        function getTabStateType(tabType) {
            var type = '';
            switch (tabType) {
                case tabStateType.documentTabState:
                    type = tabStateType.documentTabState;
                    break;
                case tabStateType.chapterTabState:
                    type = tabStateType.chapterTabState;
                    break;
                case tabStateType.homeTabState:
                    type = tabStateType.homeTabState;
                    break;
                default:
                    type = tabStateType.documentTabState;
                    break;
            }

            return type;
        };

        function initializeReadingReceiptTab() {
            if (tabStateService.isTabActive(documentTab.readingReceipt)) {
                getConfirmInformationBaseOnView();
            };
        };

        function getConfirmInformation(data) {
            readingConfirmationService.GetConfirmInformation(data.entityId)
                .then(function (response) {
                    data.confirmInformation = response.data;
                });
        };
    };

})();